import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {  useParams } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import { getreturnschart, getRollingExcessReturns, getCumulativeReturnsChart, getDistReturnsChart } from "../../../config/apiConfig";
import { Chart, ChartLegend, ChartTitle, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem, ChartSeries, ChartSeriesItem } from '@progress/kendo-react-charts';
import './ReturnsAndStatistics.css';
import moment from 'moment';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";


export const ReturnsTab = ({isGridView, ReturnsExcel}) => {  
  const [gridData,setGridData]=useState([]);
  const [gridDataLoading,setGridDataLoading]=useState(true);
  const Gstate = useSelector(state => {return state; }) || {};
  const returnsGrid = Gstate.ReturnsGridData?.ReturnsGridData?.ReturnsGrid || []; 
  useEffect(() => {
      setTimeout(()=>{
        setGridDataLoading(false)
        setGridData(returnsGrid)
      }
      ,500);
    }, [returnsGrid]);
  
  const Grid = gridData?.map(item => {
    const Jan = (item.Months[0].ReturnValue !== null) ? (item.Months[0].ReturnValue * 100).toFixed(2) : '';
    const Feb = (item.Months[1].ReturnValue !== null) ? (item.Months[1].ReturnValue * 100).toFixed(2) : '';
    const Mar = (item.Months[2].ReturnValue !== null) ? (item.Months[2].ReturnValue * 100).toFixed(2) : '';
    const Apr = (item.Months[3].ReturnValue !== null) ? (item.Months[3].ReturnValue * 100).toFixed(2) : '';
    const May = (item.Months[4].ReturnValue !== null) ? (item.Months[4].ReturnValue * 100).toFixed(2) : '';
    const Jun = (item.Months[5].ReturnValue !== null) ? (item.Months[5].ReturnValue * 100).toFixed(2) : '';
    const Jul = (item.Months[6].ReturnValue !== null) ? (item.Months[6].ReturnValue * 100).toFixed(2) : '';
    const Aug = (item.Months[7].ReturnValue !== null) ? (item.Months[7].ReturnValue * 100).toFixed(2) : '';
    const Sep = (item.Months[8].ReturnValue !== null) ? (item.Months[8].ReturnValue * 100).toFixed(2) : '';
    const Oct = (item.Months[9].ReturnValue !== null) ? (item.Months[9].ReturnValue * 100).toFixed(2) : '';
    const Nov = (item.Months[10].ReturnValue !== null) ? (item.Months[10].ReturnValue * 100).toFixed(2) : '';
    const Dec = (item.Months[11].ReturnValue !== null) ? (item.Months[11].ReturnValue * 100).toFixed(2) : '';
    const YTD = (item.YTD !== null) ? (item.YTD * 100).toFixed(2) : '';
    return {
      Year: item?.Year,
      Jan: Jan,
      Feb: Feb,
      Mar: Mar,
      Apr: Apr,
      May: May,
      Jun: Jun,
      Jul: Jul,
      Aug: Aug,
      Sep: Sep,
      Oct: Oct,
      Nov: Nov,
      Dec: Dec,
      YTD: YTD,
    }
  })
  const columnDefs = [
    { field: "Year", headerName: "Year", width: 130, cellStyle: { color: '#00609E' }, sort: "desc" },
    {
      field: "Jan", headerName: "Jan", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Feb", headerName: "Feb", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Mar", headerName: "Mar", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Apr", headerName: "Apr", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "May", headerName: "May", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Jun", headerName: "Jun", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Jul", headerName: "Jul", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Aug", headerName: "Aug", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Sep", headerName: "Sep", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Oct", headerName: "Oct", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Nov", headerName: "Nov", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "Dec", headerName: "Dec", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
    },
    {
      field: "YTD", headerName: "YTD", width: 130,
      valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
      cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : 'green' })
    },
  ];
 
  const defaultColDef = {
    sortable: false, filter: false, suppressMovable: true, flex:1,resizable:true
  } 
  return (
  <>      
    {isGridView && (
      <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
          {gridDataLoading ? <><LoadingScreen/></> :<>
          <AgGridReact
            columnDefs={columnDefs}
            rowData={Grid}
            defaultColDef={defaultColDef}
            onGridReady={params => {
              ReturnsExcel.current = params.api;
            }}
          />
          </> }
        
      </div>)
    }         
  </>
  )
}

export const VamiChart = ({isChartView,setEndDate,setStartDate,customRange}) => {   
  const [minMaxGrowth, setGrowthof1000] = useState([]);
  const [postiveNegativeReturn, setPostiveNegativeReturns] = useState([]);
  const [chartStepValue, setChartStepValue] = useState(-2);
  const Gstate = useSelector(state => {return state; }) || {};
  const vammiChart = Gstate.ReturnsGridData.vamiChartData || [];
  const getChartValues = () => {
    const Growthof1000Value = vammiChart.GrowthOf1000 || [];
    const PostiveNegative = vammiChart.PostiveNegative || [];
    setGrowthof1000(() => Growthof1000Value);
      setPostiveNegativeReturns(() => PostiveNegative);
      if (vammiChart?.GrowthOf1000?.length > 120)
          setChartStepValue(10)
      else if (vammiChart?.GrowthOf1000?.length > 60)
          setChartStepValue(2)
      else
          setChartStepValue(1)   
  };
  useEffect(() => {
      getChartValues();
      if(!customRange && setEndDate && setStartDate)
      {
        setEndDate(vammiChart.EndDate);
        setStartDate(vammiChart.StartDate);
      };
  }, [vammiChart])  
  
  const rorValues = minMaxGrowth.map((item) => item.ROR) || [];
  const posNegRor = postiveNegativeReturn.map((item) => ({
    value: item.ReturnValue,
  })) ||  [];
  const pointLength = posNegRor.length +1;
  const posRor = postiveNegativeReturn.map((item) => ({
    value: item.ReturnValue > 0 ? (item.ReturnValue) : 0,
  })) || [];
  const negRor = postiveNegativeReturn.map((item) => ({
    value: item.ReturnValue < 0 ? (item.ReturnValue) : 0,
  })) || [];
  const uniqueCategories = postiveNegativeReturn.map((item) => moment(item.PriceDate).format('MMM YYYY')) || [];
 
  return (
  <> 
    {isChartView && (<>
      <div style={{height: '0px'}}>

      <svg xmlns="https://www.w3.org/2000/svg" version="1.1" style={{width:'0', height:'0', visibility: 'hidden'}}>
      <defs>
          <linearGradient id="svg-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="100%" style={{stopColor: '#C2EAE2'}} />
          <stop offset="0%" style={{stopColor: '#FFFFFF'}} />
          </linearGradient>
      </defs>
      </svg>
  </div>
    <div style={{ width: '100%', height: '400px' }}>    
        <Chart>
          <ChartTitle />
            <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={uniqueCategories}
                                title={{ visible: false }} 
                                line={{visible:false}}
              labels={{
                  step: chartStepValue,
                  rotation: 90,
                  position: 'start'                
              }}
              justified={true}
              majorGridLines={{ visible: false }}
              axisCrossingValue={[0, pointLength, pointLength, 0]}
              color="#7D7D7D"           
            />
          </ChartCategoryAxis>
          <ChartSeries>
            <ChartSeriesItem 
            type="column" 
            data={posRor} 
            field="value" 
            justified={true} 
            color= '#05BFDB' 
            markers={{ visible: false }} 
            tooltip={{ visible: true, format: `{0:p2}` }} 
            axis="primary" 
            name="Positive Returns"/>
            <ChartSeriesItem 
            type="column" 
            data={negRor} 
            field="value" 
            justified={true} 
            color= '#FF8686' 
            markers={{ visible: false }} 
            tooltip={{ visible: true, format: `{0:p2}` }} 
            axis="primary" 
            name="Negative Returns"/>
            <ChartSeriesItem
              type="area"
              className="custom-series"
              data={rorValues}
              justified={true}
              markers={{ visible: false }}
              tooltip={{ visible: true, format: `{0:c0}` }}
              axis="secondary"
              opacity={0.3}
              color="url(#svg-gradient)"
            />
            <ChartSeriesItem
              type="line"
              className="custom-series"
              data={rorValues}
              justified={true}
              color="#1B9C85"
              markers={{ visible: false }}
              tooltip={{ visible: true, format: `{0:c0}` }}
              axis="secondary"
              stroke="#1B9C85"
              fill="#1B9C85"
              style={{ border: "2px solid #1B9C85" }}
              name="Growth of 1000"
            />
          </ChartSeries>
          <ChartLegend position="bottom" visible={true} />
          <ChartValueAxis>
            <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0:p0}', position: 'right' }} majorGridLines={{ visible: false }} />
            <ChartValueAxisItem name="secondary" color="#7D7D7D" labels={{ format: '{0:c0}' }} line={{ visible: true, axis: 'right' }} majorGridLines={{ visible: false }} />
          </ChartValueAxis>
        </Chart>
    
    </div>
    </>)
    }   
  </>
  )
}

export const RollingChart = ({currentAsset}) => {  
  const [bM1ExcRtnData, setBM1ExcRtnData] = useState([]);
  const [bM2ExcRtnData, setBM2ExcRtnData] = useState([]);
  const [clientRollRtn, setClientRollRtn] = useState([]);
  const [endRollDateData, setEndRollDateData] = useState([]);
  const [bMExcRtnSummary, setBMExcRtnSummary] = useState([]);
  const Gstate = useSelector(state =>state) || {};
  const rollingChartData = Gstate.ReturnsGridData.rollingChartData || [];
  const [Loading,setLoading]=useState(true);
  const getChartData=()=>{
    const RollingExcessReturnData = rollingChartData.RollingExcessReturnData;  
    const RollingExcessReturnSummary = rollingChartData.RollingExcessReturnSummary; 
    const BM1ExcRtn = RollingExcessReturnData?.map((item) => item.BM1ExcRtn) || [];
    const BM2ExcRtn = RollingExcessReturnData?.map((item) => item.BM2ExcRtn) || [];
    const ClientRollRtn = RollingExcessReturnData?.map((item) => item.ClientRollRtn) || [];
    const EndRollDate = RollingExcessReturnData?.map((item) => moment(item.EndRollDate).format('MMM YYYY')) || [];
    setBM1ExcRtnData(BM1ExcRtn);
    setBM2ExcRtnData(BM2ExcRtn);
    setClientRollRtn(ClientRollRtn);
    setEndRollDateData(EndRollDate);
    setBMExcRtnSummary(RollingExcessReturnSummary);
  };
  useEffect(() => {
    getChartData();
  }, [rollingChartData]);
  return (
  <> 
      <div style={{ width: '100%', height: '400px' }}>    
          <Chart>
            <ChartTitle />
            <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={endRollDateData}
                                title={{ visible: false }} 
                                line={{visible:false}}
              labels={{
                  step: 10,
                  rotation: 310,
                  position: 'start'                
              }}
              justified={true}
              majorGridLines={{ visible: false }}
              color="#7D7D7D"           
            />
          </ChartCategoryAxis>
            <ChartSeries>
            <ChartSeriesItem 
              type="column" 
              data={clientRollRtn} 
              field="value" 
              justified={true} 
              color= '#1B9C85' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:p2}` }} 
              axis="primary" 
              name={currentAsset.AssetName}
              />
              <ChartSeriesItem 
              type="column" 
              data={bM1ExcRtnData} 
              field="value" 
              justified={true} 
              color= '#FF8200' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:p2}` }} 
              axis="primary" 
              name={bMExcRtnSummary && bMExcRtnSummary[0] && bMExcRtnSummary[0].BmName}
              />
              <ChartSeriesItem 
              type="column" 
              data={bM2ExcRtnData} 
              field="value" 
              justified={true} 
              color= '#677F91' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:p2}` }} 
              axis="primary" 
              name={bMExcRtnSummary && bMExcRtnSummary[1] && bMExcRtnSummary[1].BmName}
              />
            </ChartSeries>
            <ChartLegend position="bottom" visible={true} />
            <ChartValueAxis>
              <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0:p0}', position: 'right' }} majorGridLines={{ visible: false }} />
            </ChartValueAxis>
          </Chart>

      </div>
    </>
  )
  };

export const CumulativeReturnsChart = ({startDate, endDate, radioValue,setEndDate,setStartDate,customRange}) => {   
  const [entityReturns, setEntityReturns] = useState([]);
  const [bM1Returns, setBM1Returns] = useState([]);
  const [bM2Returns, setBM2Returns] = useState([]);
  const [returnDate, setReturnDate] = useState([]);
  const [cumulativeChartStepValue, setCumulativeChartStepValue] = useState(-2);
  const Gstate = useSelector(state => {return state; }) || {};
  const cumlativeChart = Gstate.ReturnsGridData.cumulativeChartData || [];
  const cumError= Gstate.ReturnsGridData.cumChartLoadingError;
  const getChartdata=()=>{
    setEntityReturns(() => cumlativeChart?.EntityReturns);
    setBM1Returns(() => cumlativeChart?.BM1Returns);
    setBM2Returns(() => cumlativeChart?.BM2Returns);
    setReturnDate(() => cumlativeChart?.EntityReturns?.map((item) => moment(item.ReturnDate).format('MMM YYYY')) || []);
      if (cumlativeChart?.EntityReturns?.length > 120)
          setCumulativeChartStepValue(10);
      else if (cumlativeChart?.EntityReturns?.length > 60)
          setCumulativeChartStepValue(2);
      else
          setCumulativeChartStepValue(1);
  };
  useEffect(() => { 
    getChartdata();
  }, [cumlativeChart]);
  const entityReturnsValue = entityReturns?.map((item) => (item.ReturnValue *100)) || [];
  const bM1ReturnsValue = bM1Returns?.map((item) => (item.ReturnValue * 100)) || [];
  const bM2ReturnsValue = bM2Returns?.map((item) => (item.ReturnValue * 100)) || [];
  
  return (
  <> 
        <div style={{ width: '100%', height: '400px' }}>    
          <Chart>
            <ChartTitle />
            <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={returnDate}
                                title={{ visible: false }} 
                                line={{visible:false}}
              labels={{
                  step: cumulativeChartStepValue,
                  rotation: 310,
                  position: 'start'                
              }}
              justified={true}
              majorGridLines={{ visible: false }}
              color="#7D7D7D"           
            />
          </ChartCategoryAxis>
            <ChartSeries>
              <ChartSeriesItem 
              type="line" 
              data={entityReturnsValue} 
              field="value" 
              justified={true} 
              color= '#1B9C85' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:n2}` }} 
              axis="primary" 
              name={entityReturns && entityReturns[0] && entityReturns[0].EntityName}
              />
              <ChartSeriesItem 
              type="line" 
              data={bM1ReturnsValue} 
              field="value" 
              justified={true} 
              color= '#05BFDB' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:n2}` }} 
              axis="primary" 
              name={bM1Returns && bM1Returns[0] && bM1Returns[0].EntityName}
              />
               <ChartSeriesItem 
              type="line" 
              data={bM2ReturnsValue} 
              field="value" 
              justified={true} 
              color= '#FF8686' 
              markers={{ visible: false }} 
              tooltip={{ visible: true, format: `{0:n2}` }} 
              axis="primary" 
              name={bM2Returns && bM2Returns[1] && bM2Returns[0].EntityName}
              />
            </ChartSeries>
            <ChartLegend position="bottom" visible={true} />
            <ChartValueAxis>
              <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0}%', position: 'right' }} majorGridLines={{ visible: false }} />
            </ChartValueAxis>
          </Chart>
      </div>
  </>
  )
}

export const DistReturnsChart = ({ startDate, endDate, radioValue, setEndDate, setStartDate, customRange }) => {
  const [render, setRender] = useState(true);  
  const [entityReturns, setEntityReturns] = useState([]);
  const [bM1Returns, setBM1Returns] = useState([]);
  const [bM2Returns, setBM2Returns] = useState([]);
  const [bmRange, setBMRange] = useState([]);
  
  const params = useParams();
  const Gstate = useSelector(state => {return state; }) || {};
  const DistChartData = Gstate.ReturnsGridData.DistChartData || {};
  const getChartData=()=>{
    const EntityReturns = DistChartData.EntityReturns;
    const BM1Returns = DistChartData.BM1Returns;
    const BM2Returns = DistChartData.BM2Returns;
    const BMRange = EntityReturns?.map((item) => item.BenchmarkRange) || [];
    setEntityReturns(() => EntityReturns);
    setBM1Returns(() => BM1Returns);
    setBM2Returns(() => BM2Returns);
    setBMRange(() => BMRange);  
  }
  // const getDistReturnsChartValues = async () => {
  //   try {
  //     let response;
  //     if (startDate !== "" && startDate !== undefined && endDate !== "" && endDate !== undefined && radioValue !== undefined) {
  //       response = await axios.get(`${getDistReturnsChart}${params.Asset},${1},${startDate},${endDate},${radioValue}`);
  //       const EntityReturns = response.data.EntityReturns;
  //       const BM1Returns = response.data.BM1Returns;
  //       const BM2Returns = response.data.BM2Returns;
  //       const BMRange = EntityReturns.map((item) => item.BenchmarkRange);
  //       setEntityReturns(() => EntityReturns);
  //       setBM1Returns(() => BM1Returns);
  //       setBM2Returns(() => BM2Returns);
  //       setBMRange(() => BMRange);         
  //     } 
  //   } catch (error) {
  //     console.error(error);
  //   }    
  // }

  useEffect(() => {
    getChartData();  
  }, [DistChartData]);

  const entityReturnsValue = entityReturns?.map((item) => (item.MonthlyReturnCount)) || [];
  const bM1ReturnsValue = bM1Returns?.map((item) => (item.MonthlyReturnCount)) || [];
  const bM2ReturnsValue = bM2Returns?.map((item) => (item.MonthlyReturnCount)) || [];
  
  return (
  <> 
        <div style={{ width: '100%', height: '400px' }}>    
          <Chart>
            <ChartTitle />
            <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={bmRange}
                                title={{ visible: false }} 
                                line={{visible:false}}
              labels={{
                  rotation: 310,
                  position: 'start'                
              }}
              justified={true}
              majorGridLines={{ visible: false }}
              color="#7D7D7D"           
            />
          </ChartCategoryAxis>
            <ChartSeries>
              <ChartSeriesItem 
              type="column" 
              data={entityReturnsValue} 
              field="value" 
              justified={true} 
              color= '#1B9C85' 
              markers={{ visible: false }} 
              tooltip={{ visible: true }} 
              axis="primary" 
              name={entityReturns && entityReturns[0] && entityReturns[0].EntityName}
              />
              <ChartSeriesItem 
              type="column" 
              data={bM1ReturnsValue} 
              field="value" 
              justified={true} 
              color= '#05BFDB' 
              markers={{ visible: false }} 
              tooltip={{ visible: true }} 
              axis="primary" 
              name={bM1Returns && bM1Returns[0] && bM1Returns[0].EntityName}
              />
               <ChartSeriesItem 
              type="column" 
              data={bM2ReturnsValue} 
              field="value" 
              justified={true} 
              color= '#FF8686' 
              markers={{ visible: false }} 
              tooltip={{ visible: true }} 
              axis="primary" 
              name={bM2Returns && bM2Returns[1] && bM2Returns[0].EntityName}
              />
            </ChartSeries>
            <ChartLegend position="bottom" visible={true} />
            <ChartValueAxis>
              <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0}', position: 'right' }} majorGridLines={{ visible: false }} />
            </ChartValueAxis>
          </Chart>
      </div>
  </>
  )
}